<template>
    <div
        class="visualization sectores-visualization"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <div class="row" v-show="!showDetails">
            <div class="col-sm-3">
                <div class="sidebar">
                    <!--
                    <a href="#" class="btn btn-block btn-light" :class="{active: sector === null}">Todos</a>
                    <a v-for="s in sectores" href="#" class="btn btn-block btn-light" :class="{active: sector === s}">{{s}}</a>
                    -->
                    <el-radio-group v-model="input.sector" size="medium">
                        <el-radio-button :label="null">
                            <div class="label">Todos</div>
                        </el-radio-button>
                        <el-radio-button
                            :key="s.id"
                            v-for="s in sectores"
                            :label="s.codigo"
                            border
                            :checked="true"
                        >
                            <div
                                class="color-indicator"
                                :style="{ backgroundColor: color(s.codigo) }"
                            ></div>
                            <!--
                            <div class="icon">
                                <img :src="'/images/icons/sector_' + s.codigo + '.svg'" />
                            </div>-->
                            <div class="label">{{ s.nombre }}</div>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="col-sm-9">
                <div class="row">
                    <div class="col-sm-6">
                        <h3>Todos los Sectores Económicos</h3>
                    </div>
                </div>
                <stacked-bar-chart
                    :data="filteredData"
                    :dimensions="dimensions"
                    @detail-clicked="detailClicked"
                    :color="color"
                    :mode="chartMode"
                    :labels="labels"
                ></stacked-bar-chart>
            </div>
        </div>
        <div v-show="showDetails">
            <a
                href="#"
                @click.prevent="
                    detailWhere.periodo = null;
                    detailWhere.sector = null;
                "
                >< Volver al gráfico</a
            >
            <expenses-detail-visualization
                :where="detailWhere"
                ref="detailViz"
            ></expenses-detail-visualization>
        </div>
    </div>
</template>
<style lang="scss">
.sectores-visualization {
    .sidebar {
        height: 750px;
        overflow: scroll;
        border: 1px solid #d6d5d5;
        .el-radio-group {
            display: block;
            .el-radio-button {
                display: block;
                margin-bottom: 0;
                .el-radio-button__inner {
                    display: block;
                    white-space: normal;
                    border: none;
                    border-bottom: 1px solid #d6d5d5;
                    box-shadow: none;
                    border-radius: 0;
                    background: #f7f7f7;
                    text-align: left;
                    font-size: 16px;
                    color: #808080;
                    padding-left: 30px;
                    .label {
                        margin-bottom: 5px;
                    }
                    .color-indicator {
                        width: 10px;
                        height: 10px;
                        border-radius: 5px;
                        position: absolute;
                        top: 50%;
                        left: 13px;
                        margin-top: -(18px/2);
                    }
                }
                &.is-active {
                    .el-radio-button__inner {
                        background: inherit;
                        color: inherit;
                        .label {
                            color: #0098ff;
                        }
                    }
                }
            }
        }
    }
}
</style>
<script>
import * as d3 from 'd3';
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import StackedBarChart from '../Charts/StackedBar';
import ExpensesDetailVisualization from './ExpensesDetail';

export default {
    data: function() {
        return {
            input: {
                sector: null
            },
            detailWhere: {
                sector: null,
                periodo: null
            },
            loading: false,
            data: [],
            sectores: [],
            mode: 'chart',
            dimensions: { ordinal: ['sector'], time: ['periodo'] },
            url:
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify(['periodo', 'sector']) +
                '&order-by=' +
                JSON.stringify(['periodo', 'asc'])
        };
    },
    components: {
        StackedBarChart,
        ExpensesDetailVisualization
    },
    computed: {
        chartMode() {
            if (this.input.sector) return 'absolute';

            return 'percentage';
        },
        showDetails() {
            return this.detailWhere.periodo && this.detailWhere.sector;
        },
        periodos: function() {
            return _(this.data)
                .uniqBy('periodo')
                .map(d => {
                    return d.periodo;
                })
                .value();
        },

        filteredData: function() {
            return _(this.data)
                .filter(d => {
                    if (this.input.sector !== null) {
                        if (this.input.sector !== d.sector) return false;
                    }

                    return true;
                })
                .value();
        },
        color: function() {
            return d3.scaleOrdinal([
                '#A745AD',
                '#000000',
                '#D35A98',
                '#49006A',
                '#DB0A5B',
                '#32515D',
                '#008000',
                '#DC2A2A',
                '#DD88B3',
                '#005500',
                '#34385E',
                '#1D91C0',
                '#8A2BE2',
                '#B22222',
                '#DC143C',
                '#081D58',
                '#7A0177',
                '#F7B538',
                '#00A3A5',
                '#E97047',
                '#28A228'
            ]);
        },
        labels() {
            if (this.sectores.length === 0) return null;

            const labels = {};
            this.sectores.forEach(d => {
                labels[d.codigo] = d.nombre;
            });

            return labels;
        }
    },

    methods: {
        refreshSectors() {
            axios.get('/api/v1/sectors').then(response => {
                this.sectores = response.data;
            });
        },
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;

                this.data = _(response.data)
                    .filter(d => {
                        return d.sector !== null;
                    })
                    .value();

                //Normalizamos los valores
                /*
                const totals = _(this.data)
                    .groupBy('periodo')
                    .mapValues(d => {
                        return _.sumBy(d, 'sum');
                    })
                    .value();

                _(this.data).forEach(d => {
                    d.sum = d.sum / totals[d.periodo];
                });
                */
            });
        },
        detailClicked: function({ periodo, sector }) {
            this.detailWhere = { periodo, sector };
        }
    },
    mounted: function() {
        this.refreshData();
        this.refreshSectors();
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Sectors.vue